<template>
  <section class="pa-icon-bar">
    <ul class="pa-icon-menu">
      <li v-for="(slot, key) in iconSlot" :key="key" :class="icons[slot].additionalClass">
        <template v-if="icons[slot].additionalClass['is-disabled'] === true">
          <div class="icon-image">
            <component :is="icons[slot].componentName" class="pa-icon"></component>
          </div>
        </template>
        <template v-else>
          <router-link :to="icons[slot].to">
            <div class="icon-image">
              <component :is="icons[slot].componentName" class="pa-icon"></component>
            </div>
          </router-link>
        </template>
      </li>
    </ul>
  </section>
</template>

<script>
import PAIconHome       from '@/components/Parts/GlobalHeaderForLoginedView/IconBar/images/home.svg?inlineN'
import PAIconPark       from '@/components/Parts/GlobalHeaderForLoginedView/IconBar/images/park.svg?inlineN'
import PAIconConnection from '@/components/Parts/GlobalHeaderForLoginedView/IconBar/images/connection.svg?inlineN'
import PAIconOffice     from '@/components/Parts/GlobalHeaderForLoginedView/IconBar/images/office.svg?inlineN'
import PAIconSofa       from '@/components/Parts/GlobalHeaderForLoginedView/IconBar/images/sofa.svg?inlineN'

import CharacterMetaMixins from '@/mixins/CharacterMetaMixins.js'

export default {
  components : {
    PAIconHome,
    PAIconPark,
    PAIconConnection,
    PAIconOffice,
    PAIconSofa
  },

  mixins : [
    CharacterMetaMixins
  ],

  data(){
    return {
      isInitialized : false,

      iconSlot  : {
        'home'        : 'home',
        'park'        : 'park',
        'connection'  : 'connection',
        'office'      : 'office'
      },

      icons : {
        home         : {
          to              : {name : 'home'},
          additionalClass : {
            'icon-slot-home'      : true,
            'is-active'           : false,
            'is-active-replace'   : false,
            'is-selected'         : false,
            'is-disabled'         : false,
          },
          componentName   : 'PAIconHome',
        },

        park         : {
          to              : {name : 'parks'},
          additionalClass : {
            'icon-slot-park'      : true,
            'is-active'           : false,
            'is-active-replace'   : false,
            'is-selected'         : false,
            'is-disabled'         : false,
          },
          componentName   : 'PAIconPark',
        },

        connection   : {
          to              : {name : 'connections'},
          additionalClass : {
            'icon-slot-connection': true,
            'is-active'           : false,
            'is-active-replace'   : false,
            'is-selected'         : false,
            'is-disabled'         : false,
          },
          componentName   : 'PAIconConnection',
        },

        office       : {
          to              : {name : 'office'},
          additionalClass : {
            'icon-slot-office'    : true,
            'is-active'           : false,
            'is-active-replace'   : false,
            'is-selected'         : false,
            'is-disabled'         : false,
          },
          componentName   : 'PAIconOffice',
        },

        sofa         : {
          to              : {name : 'office'},
          additionalClass : {
            'is-active'           : false,
            'is-active-replace'   : false,
            'is-selected'         : false,
            'is-disabled'         : false,
          },
          componentName   : 'PAIconSofa',
        }
      },

      officeIconType    : 'office',

      shouldSofaShownImmediately  : false,
      debugSofa                   : false,  // When set true, sofa will open 100%
    };
  },

  computed : {
    routingPosition(){
      return this.$store.state.routingPosition;
    },

    isVisiblePageContent(){
      return this.$store.state.layouts.isVisiblePageContent;
    },

    shoudMesageRoomSofa(){
      return this.$store.state.message.shoudMesageRoomSofa;
    }
  },

  watch : {
    routingPosition : {
      handler(){
        this.setIconSelectedFlag();
      },
      immediate: true,
    },

    isVisiblePageContent : {
      handler(value){
        if((value === true) && (this.isInitialized === false)){
          this.$nextTick(() => {
            this.initializeIcon();
          });
        }
      },
      immediate: true
    },

    characterMetaData : {
      handler(data){
        if(data === {}) return;

        this.shouldSofaShownImmediately = data['messages.visibleSofaImmediately'];
        
        if(data['messages.couldEnterSofa'] === true){
          this.requestChangeRoomTypeSofa();
        }
      },
      immediate: true,
      deep: true
    },

    officeIconType : {
      handler(value){
        if(this.isInitialized === true){
          this.slotChangeTo('office', value);
        }else{
          this.iconSlot['office'] = value;
        }

        this.setIconSelectedFlag();
      }
    },

    shoudMesageRoomSofa : {
      handler(value){
        if(value === true){
          this.officeIconType = 'sofa';
        }else{
          this.officeIconType = 'office';
        }
      },
      immediate: true
    },
  },

  methods : {
    SofaOpenLotteryTime(forceful = false, defaultWaitTime = .1){
      if(forceful === true) return defaultWaitTime;

      const lottery = this._.random(1, 2);

      // Sofa will be displayed with 50% chance.
      if(lottery === 1){
        // If sofa shown, get display waiting time(minute).
        return this._.random(1, 3);
      }else{
        return false;
      }
    },
    
    requestChangeRoomTypeSofa(){
      const setShowSofaFlag = () => {
        if(this.routingPosition !== 'office'){
          this.$store.dispatch({
            type  : 'message/updateShouldMessageRoomSofa',
            value : true
          });

          console.log('sofa showed.');
        }
      };

      if(this.shouldSofaShownImmediately === true){
        console.log('sofa shown with immediately.');

        setShowSofaFlag();
      }else{
        console.log('sofa shown with lottery.');

        const waitTime = this.SofaOpenLotteryTime(this.debugSofa);

        if( waitTime === false ) return;

        console.log('Sofa wll be shown at after '+waitTime+' minute.');

        setTimeout(setShowSofaFlag, ((1000*60)*waitTime));
      }
    },

    slotActive(slotName){
      const slotIconName = this.iconSlot[slotName];
      
      this.icons[slotIconName].additionalClass['is-active'] = true;
    },

    slotChangeTo(iconSlotName, afterIconName, beforeIconName){
      if(typeof beforeIconName === 'undefined'){
        beforeIconName = this.iconSlot[iconSlotName];
      }

      this.icons[beforeIconName].additionalClass['is-active'] = false;
      this.icons[beforeIconName].additionalClass['is-active-replace'] = false;
      this.icons[afterIconName].additionalClass['is-active-replace'] = false;

      setTimeout(() => {
        this.iconSlot[iconSlotName] = afterIconName;
        this.icons[afterIconName].additionalClass['is-active-replace'] = true;
      }, 500);
    },

    initializeIcon(){
      this.slotActive('home');
      this.slotActive('park');
      this.slotActive('connection');
      this.slotActive('office');

      this.isInitialized = true;
    },

    setIconSelectedFlag(){
      let iconPosition = this.routingPosition;
      
      if(this.routingPosition === 'office' && this.officeIconType === 'sofa'){
        iconPosition = 'sofa';
      }

      if(this.icons[iconPosition].additionalClass['is-disabled'] === true) return;

      for(let i in this.icons){
        this.icons[i].additionalClass['is-selected'] = false;
      }

      this.icons[iconPosition].additionalClass['is-selected'] = true;
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@keyframes globalIconFadeIn
{
  0%  {
    transform:scale(.8);
    transform: rotate(10deg);
    opacity:0;
  }
  70% {
    transform: scale(1.1);
    transform: rotate(-10deg);
    opacity:.7;
  }
  100% {
    transform:scale(1);
    transform: rotate(0);
    opacity:1;
  }
}

@keyframes globalIconReplaceIn {
  0%  {
    transform:scale(.7);
    opacity:0;
    margin-top:-70px;
  }

  100% {
    margin-top:0;
    transform:scale(1);
    opacity:1;
  }
}

section.pa-icon-bar{
  background: -webkit-linear-gradient(#B2967F, #AA8F75);
  background: linear-gradient(#B2967F, #AA8F75);
  width:100vw;
  position: fixed;
  left: 0;
  bottom:0;
  z-index:9;

  @include from($desktop) {
    position:static;
    left:inherit;
    bottom: inherit;
    width:100%;
    background: inherit;
  }
  
  ul.pa-icon-menu{
    display: flex;
    flex-direction: row;
    padding-top:1.5vw;
    padding-bottom: calc(env(safe-area-inset-bottom) + 1vw);
    overflow: hidden;

    @include from(768px) {
      padding-top:10px;
      padding-bottom: calc(env(safe-area-inset-bottom) + 5px);

      width:400px;
      margin:0 auto;
    }

    li{
      opacity:0;
      width:20%;
      height:inherit;
      margin-left:2%;
      margin-right:2%;
      text-align: center;
      position: relative;
      transition: opacity .5s ease-out;

      &.is-active{
        animation: globalIconFadeIn 1s normal ease-out;
        opacity:1;

        &-replace{
          animation: globalIconReplaceIn 1s normal ease-in-out;
          opacity:1;
          margin-top:0;
        }
      }

      &.is-selected{
        .icon-image{
          svg.pa-icon{
            .b{
              fill:#913d60;
            }
          }
        }
      }

      &.is-disabled{
        .icon-image{
          svg.pa-icon{
            .b{
              fill:#BDA996;
            }
          }
        }
      }

      &:first-child{
        margin-left:4%;
      }

      &:last-child{
        margin-right:4%;
      }

      a{
        width:100%;
      }

      .icon-image{
        width:100%;

        svg.pa-icon{
          width:70%;
          margin:0 auto;

          .a{
            fill:none;
          }

          .b{
            fill:#d1d1d1;
          }
        }
      }
    }

    @include from($desktop) {
      padding-top:0;
      padding-bottom:0;

      li{
        .icon-image{
          svg.pa-icon{
            .b{
              fill:#913D60;
            }
          }
        }

        &.is-selected{
          .icon-image{
            svg.pa-icon{
              .b{
                fill:#AE8428;
              }
            }
          }
        }

        &.is-disabled{
          .icon-image{
            svg.pa-icon{
              .b{
                fill:#6A2338;
              }
            }
          }
        }
      }
    }
  }
}
</style>